/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconToolsKitchen = createReactComponent("tools-kitchen", "IconToolsKitchen", [
  ["path", { d: "M4 3h8l-1 9h-6z", key: "svg-0" }],
  ["path", { d: "M7 18h2v3h-2z", key: "svg-1" }],
  ["path", { d: "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z", key: "svg-2" }],
  ["path", { d: "M20 15v6h-1v-3", key: "svg-3" }],
  ["path", { d: "M8 12l0 6", key: "svg-4" }]
]);

export { IconToolsKitchen as default };
//# sourceMappingURL=IconToolsKitchen.js.map
